"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SelectItemPropTypes = exports.OptgroupPropTypes = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
const SelectItemPropTypes = exports.SelectItemPropTypes = {
  /** The label to display visually in the Select. */
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]).isRequired,
  /** The value to return when a selection is made. */
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]).isRequired,
  /** Whether the option is disabled. */
  disabled: _propTypes.default.bool
};
const OptgroupPropTypes = exports.OptgroupPropTypes = {
  /** The optgroup label within the list of options */
  label: _propTypes.default.string,
  /** An array of options with label/value pairs */
  optgroup: _propTypes.default.arrayOf(_propTypes.default.shape(SelectItemPropTypes))
};
var _default = exports.default = SelectItemPropTypes;